/**
 * Onboarding value-prop slides shown in the signed-in / no-household
 * onboarding gate. Mirrors iOS `ValuePropSlide` in
 * `zoey_ios/ZoeyApp/ZoeyApp/ContentView.swift`. Keep copy in sync across
 * platforms per [[specs/new-user-onboarding-and-join-flow]].
 *
 * `objectPosition` is the CSS analog of the iOS `imageHorizontalOffset`.
 * iOS shifts the image left by 80pt for slide 2 so the child on the back
 * of the e-bike stays in frame — on the web we achieve the same crop by
 * anchoring the object-position to the right edge of the source.
 */
export interface ValuePropSlide {
  id: string;
  imageSrc: string;
  taglineKey: string;
  /** CSS `object-position` value for the hero image. Defaults to `center`. */
  objectPosition?: string;
}

export const valuePropSlides: ValuePropSlide[] = [
  {
    id: "sync",
    imageSrc: "/images/onboarding/onboarding-slide-1-sync.jpg",
    taglineKey: "valueProp.sync.tagline",
  },
  {
    id: "fun",
    imageSrc: "/images/onboarding/onboarding-slide-2-fun.jpg",
    taglineKey: "valueProp.fun.tagline",
    // iOS nudges this image -80pt so the kid on the back of the e-bike
    // stays in frame after the center-crop. On the web, anchoring the
    // object-position right-of-center achieves the same reveal.
    objectPosition: "75% center",
  },
  {
    id: "shared",
    imageSrc: "/images/onboarding/onboarding-slide-3-shared.jpg",
    taglineKey: "valueProp.shared.tagline",
  },
];
